module.exports = __webpack_public_path__ + "img/rock-big-08.a4d18392.png";